const GAS_LIMIT = process.env.REACT_APP_DEFAULT_GAS_LIMIT || '';

export const fetchAllTokenIds = async (drizzle: any) => {
  const totalSupply = await drizzle.contracts.RollStatue.methods
    .totalSupply()
    .call();

  return [...new Array(+totalSupply).keys()].map((i) => i + 1);
};

export const getAllOwnerTokenIds = async (drizzle: any, owner: string) => {
  try {
    const ownerIndices = await drizzle.contracts.RollStatue.methods
      .getStatueIndicesByOwner(owner)
      .call();

    const ids: string[] = ownerIndices.map((o: string) => Number(o) + 1);

    console.log(ids);
    return ids;
  } catch (error) {
    throw new Error(`Failed to get owner token ids. Error: ${error}`);
  }
};

export const roll = async (
  drizzle: any,
  from: string,
  first: string,
  second: string,
  third: string
) => {
  const result = await drizzle.contracts.RollStatue.methods
    .roll(first, second, third)
    .send({ value: 100, from });

  console.log(result);
};

export const transferToken = async (
  drizzle: any,
  tokenId: string,
  from: string,
  to: string
) => {
  console.log('Transferring...');
  await drizzle.contracts.RollStatue.methods
    .transferFrom(from, to, tokenId)
    .send({ gasLimit: GAS_LIMIT, from });
  console.log('Transfer Complete!');
  return 'success';
};

export const getTokenURI = async (drizzle: any, tokenId: string) => {
  const metadataUrl: string = await drizzle.contracts.RollStatue.methods
    .tokenURI(tokenId)
    .call();

  // Temporary workaround
  return metadataUrl.replace('7000//', '7000/');
};
